module.exports = __webpack_public_path__ + "static/media/DataIntegration.c801c20b.svg";